import React, { PropsWithChildren } from 'react'
import './index.scss'
import { ICONS, IconType } from '@Const/common'
import clsx from 'clsx'
import CircledIcon from '@Components/CircledIcon'

interface ViewWorkSectionProps {
    icon: IconType
    title: string
    count?: number
    rightData?: React.ReactElement
    valid?: boolean
}

const ViewWorkSection = ({
    icon,
    title,
    count,
    rightData,
    valid,
    children,
}: PropsWithChildren<ViewWorkSectionProps>) => (
    <div className="view-work-section">
        <div className="work-section-header">
            <div className={clsx('validity-img', valid || 'invalid')}>
                {valid !== undefined && (
                    <img src={valid ? ICONS.check : ICONS.error} alt={valid ? 'Valid' : 'Invalid'} />
                )}
            </div>
            <CircledIcon icon={icon} alt={title} />
            <h5>
                {title} {(count || count === 0) && '(' + count + ')'}
            </h5>
            {rightData && <div className="right-data">{rightData}</div>}
        </div>
        {children}
    </div>
)

export default ViewWorkSection
